/**
 * PATH: apps/quote/src/components/builder/other-charges-section/AddChargeForm.tsx
 * PURPOSE: Form for adding a new other charge
 */

import { useState } from 'react'
import { CATEGORY_OPTIONS, getCategoryLabel, type OtherCharge } from './types'

export function AddChargeForm({ onAdd, onCancel }: {
  onAdd: (data: Partial<OtherCharge>) => void; onCancel: () => void
}) {
  const [category, setCategory] = useState('pm_supervision')
  const [description, setDescription] = useState('')
  const [quantity, setQuantity] = useState('1')
  const [rate, setRate] = useState('')
  const [marginPercent, setMarginPercent] = useState('50')

  const handleSubmit = () => {
    const categoryInfo = CATEGORY_OPTIONS.find(c => c.value === category)
    onAdd({
      category,
      description: description || getCategoryLabel(category),
      quantity: parseFloat(quantity) || 1,
      rate: parseFloat(rate) || 0,
      margin_percent: parseFloat(marginPercent) / 100 || 0,
      is_deduction: categoryInfo?.isDeduction || false,
    })
  }

  return (
    <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg mb-2">
      <div className="grid grid-cols-6 gap-3">
        <div className="col-span-2">
          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full h-9 px-2 text-sm border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800">
            {CATEGORY_OPTIONS.map(opt => (<option key={opt.value} value={opt.value}>{opt.icon} {opt.label}</option>))}
          </select>
        </div>
        <div className="col-span-2">
          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Description</label>
          <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder={getCategoryLabel(category)} className="w-full h-9 px-2 text-sm border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Qty</label>
          <input type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} className="w-full h-9 px-2 text-sm border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800 text-right" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Rate ($)</label>
          <input type="number" value={rate} onChange={(e) => setRate(e.target.value)} placeholder="0.00" className="w-full h-9 px-2 text-sm border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800 text-right" />
        </div>
      </div>
      <div className="flex items-center gap-3 mt-3">
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Markup %</label>
          <input type="number" value={marginPercent} onChange={(e) => setMarginPercent(e.target.value)} className="w-20 h-8 px-2 text-sm border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800 text-right" />
        </div>
        <div className="flex-1" />
        <button onClick={onCancel} className="px-3 py-1.5 text-sm border border-slate-300 dark:border-slate-600 rounded hover:bg-slate-100 dark:hover:bg-slate-700">Cancel</button>
        <button onClick={handleSubmit} disabled={!rate} className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">Add Charge</button>
      </div>
    </div>
  )
}
